import { Outlet } from "react-router-dom";

const TopicLayout = () => {
  return <Outlet />;
};
export default TopicLayout;
